export interface SmartDefaults {
  cameraAngle?: string;
  lens?: string;
  shotSize?: string;
  lighting?: string;
  composition?: string;
  depthOfField?: string;
  rimLight?: boolean;
  atmosphere?: string;
}

const hasAny = (text: string, rules: RegExp[]): boolean => rules.some((rule) => rule.test(text));

export function getSmartDefaults(description: string): SmartDefaults {
  const text = description.trim().toLowerCase();
  if (!text) return {};

  const isPortrait = hasAny(text, [/\bportrait\b/, /\bface\b/, /\bcharacter\b/, /\bheadshot\b/, /\bبورتريه\b/, /\bوجه\b/, /\bشخصية\b/]);
  const isLandscape = hasAny(text, [/\blandscape\b/, /\benvironment\b/, /\bcity\b/, /\bscene\b/, /\bpanorama\b/, /\bمنظر\b/, /\bمدينة\b/, /\bبيئة\b/]);
  const isAction = hasAny(text, [/\baction\b/, /\bfight\b/, /\brunning\b/, /\bdynamic\b/, /\bmotion\b/, /\bقتال\b/, /\bجري\b/, /\bحركة\b/]);
  const isDarkNoir = hasAny(text, [/\bdark\b/, /\bnoir\b/, /\bgangster\b/, /\bcyberpunk\b/, /\bمظلم\b/, /\bنوار\b/, /\bسايبربانك\b/]);

  const defaults: SmartDefaults = {};

  if (isPortrait) {
    defaults.lens = '85mm';
    defaults.shotSize = 'close_up';
    defaults.depthOfField = 'shallow';
    defaults.lighting = 'soft cinematic lighting';
  }

  if (isLandscape) {
    defaults.lens = defaults.lens || '24mm';
    defaults.shotSize = defaults.shotSize || 'wide';
    defaults.depthOfField = defaults.depthOfField || 'deep';
    defaults.composition = 'cinematic wide composition';
  }

  if (isAction) {
    defaults.cameraAngle = 'low_angle';
    defaults.lens = defaults.lens || '35mm';
    defaults.lighting = defaults.lighting || 'dramatic contrast lighting';
    defaults.composition = defaults.composition || 'dynamic framing';
  }

  if (isDarkNoir) {
    defaults.lighting = 'high contrast cinematic lighting';
    defaults.rimLight = true;
    defaults.atmosphere = 'fog haze atmosphere';
  }

  return defaults;
}
